import { z } from 'zod';
import { IdSchema } from '../../common';
export const ScheduleQuerySchema = z.object({
    year: z.coerce.number().int().min(2000).max(2100),
    month: z.coerce.number().int().min(1).max(12),
});
export const ScheduleLessonSchema = z.object({
    courseId: IdSchema,
    courseName: z.string(),
    startTime: z.string().nullable(),
    durationMin: z.number().int().nullable(),
    kind: z.string(),
    zoomLink: z.string().nullable().optional(),
});
export const ScheduleHomeworkSchema = z.object({
    id: IdSchema,
    title: z.string(),
    courseId: IdSchema.nullable(),
    dueAt: z.string(),
});
export const ScheduleGuidanceSchema = z.object({
    type: z.enum(['weekly_plan', 'homework']),
    id: IdSchema,
    title: z.string(),
    groupId: IdSchema.optional(),
    groupName: z.string().optional(),
    contentId: IdSchema.optional(),
    rowIndex: z.number().int().optional(),
    dayOfWeek: z.number().int().min(1).max(7).optional(),
    subjectId: IdSchema.optional(),
    targetQuestionCount: z.number().int().optional(),
    note: z.string().optional(),
    dueAt: z.string().optional(),
});
export const ScheduleDeadlineSchema = z.object({
    id: IdSchema,
    title: z.string(),
    kind: z.enum(['exam', 'worksheet']),
    dueAt: z.string(),
});
export const ScheduleDaySchema = z.object({
    date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    lessons: z.array(ScheduleLessonSchema),
    homeworks: z.array(ScheduleHomeworkSchema),
    guidance: z.array(ScheduleGuidanceSchema),
    deadlines: z.array(ScheduleDeadlineSchema).optional(),
});
export const ScheduleResponseSchema = z.object({
    days: z.array(ScheduleDaySchema),
    month: z.number().int().min(1).max(12),
    year: z.number().int(),
});
//# sourceMappingURL=schedule.js.map